import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Paper from "@material-ui/core/Paper";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/styles";
import API from "../../actions";
import Copyright from "./Copyright";
import styles from "./styles";

const useStyles = makeStyles(styles);

export default props => {
    const classes = useStyles();
    const [email, setEmail] = useState("");
    const [sending, setSending] = useState(false);

    useEffect(() => {
        if (!sending) return;
        API.resetPassword(email).then(
            () => alert("Der er blevet sendt en mail til " + email),
            err => {
                if (err === "user not found") alert("Der findes ingen konto tilknyttet denne email");
                else alert("Der skete en fejl: " + err);
                setSending(false);
            }
        );
    }, [sending, email]);

    return (
        <Grid container component="main" className={classes.root}>
            <CssBaseline />
            <Grid item xs={false} sm={4} md={7} className={classes.image} />
            <Grid item xs={12} sm={8} md={5} component={Paper} elevation={6} square>
                <div className={classes.paper}>
                    <Avatar className={classes.avatar}>
                        <LockOutlinedIcon />
                    </Avatar>
                    <Typography component="h1" variant="h5">
                        Glemt password
                    </Typography>
                    <form
                        className={classes.form}
                        onSubmit={event => {
                            event.preventDefault();
                            setSending(true);
                        }}>
                        <TextField
                            variant="outlined"
                            margin="normal"
                            required
                            fullWidth
                            label="Email"
                            value={email}
                            onChange={event => setEmail(event.target.value)}
                        />
                        <Button type="submit" fullWidth variant="contained" color="primary" className={classes.submit}>
                            Nulstil password
                        </Button>
                        <Grid container>
                            <Grid item xs></Grid>
                            <Grid item>
                                <Link
                                    to={{
                                        pathname: "/"
                                    }}
                                    variant="body2">
                                    {"Tilbage"}
                                </Link>
                            </Grid>
                        </Grid>
                        <Box mt={5}>
                            <Copyright />
                        </Box>
                    </form>
                </div>
            </Grid>
        </Grid>
    );
};
